import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];
import React from 'react';
import Box from '../Box';
import Content from '../Content';
import BaseLink from '../Link';
import { useThemeDefaults } from '../utils';
var FooterOuter = useThemeDefaults(function (_ref) {
  var theme = _ref.theme;
  return {
    as: 'footer',
    bg: theme.footer.bg,
    width: '100%',
    pb: theme.footer.pb,
    pt: theme.footer.pt,
    spaceAbove: theme.footer.spaceAbove
  };
}, Box);

var Footer = function Footer(_ref2) {
  var children = _ref2.children,
      props = _objectWithoutProperties(_ref2, _excluded);

  return /*#__PURE__*/React.createElement(FooterOuter, props, /*#__PURE__*/React.createElement(Content, null, children));
};

export var Link = Footer.Link = function (props) {
  return /*#__PURE__*/React.createElement(BaseLink, _extends({
    color: "inherit",
    hoverColor: "label",
    href: "#"
  }, props));
};
export default Footer;